import { c as _c } from "react/compiler-runtime";
import { FontWeights, Skeleton, Tooltip } from "@flat-ui";
import { useCompanyId } from "@context-providers/company-id-provider";
import { generateProjectDetailsRoute } from "@router/router-helper";
import { getProjectByIdSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { withEllipsis } from "@styles/common-styles";
import { ProjectEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { Link } from "react-router-dom";
import styles from "@components/table/projects/projects-table.module.css";
import { fetchingTransactionsFlagsSelector } from "@store/credit-transactions/credit-transactions-selector";
import { UiUtils } from "@stellar/utils";
/** Renders the user column fields in transactions table */
export function TransactionProject(t0) {
  const $ = _c(27);
  const {
    projectId
  } = t0;
  const companyId = useCompanyId();
  const {
    trackEvent
  } = useTrackEvent();
  let t1;
  if ($[0] !== projectId) {
    t1 = getProjectByIdSelector(projectId);
    $[0] = projectId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const project = useAppSelector(t1);
  const {
    status
  } = useAppSelector(fetchingTransactionsFlagsSelector);
  if (!projectId) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <var>{UiUtils.DASH}</var>;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  if (!project && status === "succeeded") {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Skeleton sx={{
        width: "100%",
        height: "auto"
      }} />;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  if (!project) {
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        ...withEllipsis,
        fontWeight: FontWeights.Bold
      };
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== projectId) {
      t3 = <Tooltip component="div" title="Project could not be found in the workspace." sx={t2}><var>{projectId}</var></Tooltip>;
      $[5] = projectId;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  let t2;
  if ($[7] !== trackEvent) {
    t2 = function handleClick(e, projectId_0) {
      trackEvent({
        name: ProjectEvents.openProjectDetails,
        props: {
          projectId: projectId_0,
          eventLocation: "transactions-table"
        }
      });
      e.stopPropagation();
    };
    $[7] = trackEvent;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const handleClick = t2;
  let t3;
  if ($[9] !== companyId || $[10] !== projectId) {
    t3 = generateProjectDetailsRoute(companyId, projectId);
    $[9] = companyId;
    $[10] = projectId;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== handleClick || $[13] !== projectId) {
    t4 = e_0 => handleClick(e_0, projectId);
    $[12] = handleClick;
    $[13] = projectId;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== project.name) {
    t5 = <var>{project.name}</var>;
    $[15] = project.name;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      ...withEllipsis,
      fontWeight: FontWeights.Bold
    };
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== project.name) {
    t7 = <var>{project.name}</var>;
    $[18] = project.name;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t5 || $[21] !== t7) {
    t8 = <Tooltip component="div" title={t5} sx={t6}>{t7}</Tooltip>;
    $[20] = t5;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t3 || $[24] !== t4 || $[25] !== t8) {
    t9 = <Link to={t3} onClick={t4} className={styles["removed-underline"]}>{t8}</Link>;
    $[23] = t3;
    $[24] = t4;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
}